import { get } from "./get"

const subthemes = {
  get,
}

export default subthemes
